import { DynamicComponent } from '../../dynamic-component/shared/dynamic-component';
import { WidgetComponent } from './widget.interfaces';

export class Widget extends DynamicComponent<WidgetComponent> {}
